import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import HiringDetailForm from "./updateHiringForm";
// import EditDepartmentForm from "./editDepartmentForm";

type EditDepartmentProps = {
  opened: boolean;
  onClose: () => void;
  entryId?: string;
};

function HiringModal({ opened, onClose, entryId }: EditDepartmentProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      size="lg"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Employment Details"
        onClose={onClose}
        ariaLabel="Close create Department modal"
      />
      <HiringDetailForm entryId={entryId} onClose={onClose} />
      {/* <EditDepartmentForm
        departmentId={departmentId}
        onClose={onClose}
        // deptData={deptData}
        // user={{} as User}
      /> */}
    </Modal>
  );
}

export default HiringModal;
